import { DEFAULT_BACKGROUND, DEFAULT_TEXT_EFFECT } from './themes';

// Shared contract between the control page (ChurchApp) and the projector
// page (/display). Both run in the same browser, so a same-origin
// BroadcastChannel is enough — no window handles or postMessage('*').

export const DISPLAY_PATH = '/display';
export const DISPLAY_WINDOW_NAME = 'sleekhear-display';
export const STAGE_PATH = '/stage';
export const STAGE_WINDOW_NAME = 'sleekhear-stage';
const CHANNEL_NAME = 'sleekhear-display';

// Which screen a hello/bye message comes from (no role = projector).
export const ROLE = { PROJECTOR: 'projector', STAGE: 'stage' };

export const MSG = {
  STATE: 'state', // control -> screens: { isLive, content, currentLine, style, stage }
  HELLO: 'hello', // display -> control: "I just loaded, send me the state"
  BYE: 'bye',     // display -> control: "I am closing"
  BACKGROUND: 'background', // control -> display: { imageId, blob } for an image background
};

export const DEFAULT_STYLE = {
  backgroundColor: '#000000',
  fontColor: '#ffffff',
  fontSize: 48,
  fontFamily: 'Arial',
  background: DEFAULT_BACKGROUND,
  textEffect: DEFAULT_TEXT_EFFECT,
};

// Returns null where BroadcastChannel is unsupported (very old browsers).
export function openChannel() {
  return typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(CHANNEL_NAME);
}

// Song lyrics are shown one non-empty line at a time.
export function lyricLines(text = '') {
  return text.split('\n').filter(line => line.trim() !== '');
}
